
import React from 'react';
import CareerMap360 from './CareerMap360';
import DreamBoardPlus from './DreamBoardPlus';
import PitchPlaygroundPro from './PitchPlaygroundPro';
import AICareerCoach from './AICareerCoach';
import TeenFellowshipPrograms from './TeenFellowshipPrograms';
import MonthlyMentorHours from './MonthlyMentorHours';
import ShadowFounderExperience from './ShadowFounderExperience';
import VerifiedSkillPortfolio from './VerifiedSkillPortfolio';
import CommunityLeaderBadge from './CommunityLeaderBadge';
import EarlyAccessEvents from './EarlyAccessEvents';
import MicroInternshipProgram from './MicroInternshipProgram';
import StartupNewsroomFeature from './StartupNewsroomFeature';
import ComingSoonFeature from './ComingSoonFeature';

interface FeatureRouterProps {
  activeFeature: string;
  onBack: () => void;
}

const FeatureRouter: React.FC<FeatureRouterProps> = ({ activeFeature, onBack }) => {
  const renderFeature = () => {
    switch (activeFeature) {
      case 'careerMap360':
        return <CareerMap360 />;
      case 'dreamBoardPlus':
        return <DreamBoardPlus />;
      case 'pitchPlaygroundPro':
        return <PitchPlaygroundPro />;
      case 'aiCareerCoach':
        return <AICareerCoach />;
      case 'teenFellowshipPrograms':
        return <TeenFellowshipPrograms />;
      case 'monthlyMentorHours':
        return <MonthlyMentorHours />;
      case 'shadowFounderExperience':
        return <ShadowFounderExperience />;
      case 'verifiedSkillPortfolio':
        return <VerifiedSkillPortfolio />;
      case 'communityLeaderBadge':
        return <CommunityLeaderBadge />;
      case 'earlyAccessEvents':
        return <EarlyAccessEvents />;
      case 'microInternshipProgram':
        return <MicroInternshipProgram />;
      case 'startupNewsroomFeature':
        return <StartupNewsroomFeature />;
      default:
        return <ComingSoonFeature featureName={activeFeature} />;
    }
  };

  return (
    <div className="space-y-4">
      <button
        onClick={onBack}
        className="text-blue-500 hover:text-blue-700 font-medium"
      >
        ← Back to Premium Dashboard
      </button>
      {renderFeature()}
    </div>
  );
};

export default FeatureRouter;
